const emails = require("../emailsBeta.json")

export const checkBeta = (userEmail) => {
    const isBeta = emails.filter(email => email.email == userEmail)
    if(isBeta.length >= 1) {
        return true
    } else {
        return false
    }
}